// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"f5319021","450":"1c367bce","476":"fc3af92c","745":"a1542a3b","797":"3d443f3c","830":"e4ba5036","943":"5e6fc2d0"}[chunkId] + ".chunk.js";
};